<template>
	<AppLayout
		:title="boardMember.user.full_name"
		:subtitle="boardMember.legal_rank ? trans(`association.boards.legal_ranks.${boardMember.legal_rank}`) : trans('association.boards.legal_ranks.advisoryMember')"
		:return-label="boardArea.name"
		:return-url="route('association.boards.areas.full-members.index', {board: board.id, boardArea: boardArea.id})"
	>
		<Alert :color="Color.Amber">
			<div class="flex flex-col gap-2">
				<p v-for="warning in trans('association.boards.areas.members.full.upgrade.warnings')">{{ warning }}</p>
			</div>
		</Alert>
		<CardGrid>
			<Card
				v-for="member in boardMembers"
				:title="member.user.full_name"
				:subtitle="member.legal_rank ? trans(`association.boards.legal_ranks.${member.legal_rank}`) : trans('association.boards.legal_ranks.advisoryMember')"
			>
				<template #footer>
					<SecondaryButton :color="Color.Teal" @click.stop="store('finalize', member.id)">
						<i class="fa-solid fa-check mr-2"/>
						{{ trans('association.boards.areas.members.full.finalize.title') }}
					</SecondaryButton>
					<SoftButton :color="Color.Red" @click.stop="store('expel', member.id)">
						<i class="fa-solid fa-ban mr-2"/>
						{{ trans('association.boards.areas.members.full.expel.title') }}
					</SoftButton>
				</template>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {useForm} from '@inertiajs/vue3'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import Card from '@/Components/UI/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Alert from '@/Components/UI/Alerts/Alert.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import {type Board} from '@/Types/Association/Boards/Board'
import SoftButton from '@/Components/UI/Buttons/SoftButton.vue'
import {type BoardArea} from '@/Types/Association/Boards/BoardArea'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {type BoardMember} from '@/Types/Association/Boards/BoardMember'

const props = defineProps<{
	board:Board,
	boardArea:BoardArea,
	boardMember:BoardMember,
	boardMembers:Array<BoardMember>,
}>()

const board:Ref<Board> = ref(props.board)
const working:Ref<boolean> = ref(false)
const boardArea:Ref<BoardArea> = ref(props.boardArea)
const boardMember:Ref<BoardMember> = ref(props.boardMember)
const boardMembers:Ref<Array<BoardMember>> = ref(props.boardMembers)

function store(action:string, replacedId:number):void{
	if(!working.value){
		working.value = true
		showInfo(trans('association.boards.areas.members.full.upgrade.processing'))
		useForm({
			action: action,
			replaced_id: replacedId,
		}).post(route('association.boards.areas.full-members.upgrade.store', {
			board: board.value.id,
			boardArea: boardArea.value.id,
			boardMember: boardMember.value.id,
		}), {
			onSuccess: () => {
				showSuccess(trans('association.boards.areas.members.full.upgrade.processed'))
			},
			onError: showValidationErrors,
			onFinish: () => {
				working.value = false
			},
		})
	}
}
</script>